const PROP_BUNDLE_COLOR = "Bundle Color"
const PROP_STANDARD_BUNDLE_LABEL = "Standard Bundle Label"
const CONFIRM_DELETE_ALL_CART_ITEMS = "Are you sure you want to remove all items?"

function artistIconsText(cart) {
  return;
  const artistText = $('.cart_artist_icons_text')
  artistText.hide()
  cart.items.forEach((item) => {
    const boxesColor = []
    let labeled_preview_url = false;
    if(item.properties['_custom_image_url']?.includes('labeled') || item.properties['_custom_image_url']?.includes('bundles')){
      labeled_preview_url = item.properties['_custom_image_url'].replace(/&amp;/g, '&');;
    }
    
    Object.keys(item.properties).forEach((prop)=>{
      if (prop.includes(PROP_BUNDLE_COLOR))
        boxesColor.push(bundleColorValues.indexOf(item.properties[prop]) + 1)
        
      if (prop.includes(PROP_STANDARD_BUNDLE_LABEL) && isLabelForPreorder(item.properties[prop])) {
        artistText.show()
      }
    })
    if (isArakiProduct(item.handle)) {
      artistText.show()
    }

    

    if (isCorporateGifts(item.handle)) {
      const twoCapsules = 2
      const fourCapsules = 4
      const fiveCapsules = 5
      if (boxesColor.length === twoCapsules) {
        boxesColor.splice(0, 0, 0);
      }
      if (boxesColor.length === fourCapsules) {
        boxesColor.splice(3, 0, 0);
        boxesColor.push(0)
      }
      if (boxesColor.length === fiveCapsules) {
        boxesColor.unshift(0)
      }
    }
    //LANDINGPAGES2024 -- this is where we decide which image service to use
    if(labeled_preview_url){
      $(`[data-cart-item-id="${item.key}"]`).find('.cart__product-image').attr('style',
      `background-image: url("${labeled_preview_url}");` ).removeAttr('data-bgset')
    }else if (canUseDynaCapsule(boxesColor, item.handle)) {
      const { typeParam, isCorporate } = imageServiceParams(item.handle)
      $(`[data-cart-item-id="${item.key}"]`).find('.cart__product-image').attr('style',
        `background-image: url("https://dynacapsule.com/labeled.php?product=${item.handle}&colors=${boxesColor.join(',')}");` ).removeAttr('data-bgset')
    
      }else if (canUseImageService(boxesColor, item.handle)) {
      const { typeParam, isCorporate } = imageServiceParams(item.handle)
        $(`[data-cart-item-id="${item.key}"]`).find('.cart__product-image').attr('style',
        `background-image: url("${image_service_url}/api/image?${typeParam}device=thumbnail&capsules=${boxesColor.join(',')}${isCorporate}&source=cart-js");` ).removeAttr('data-bgset')
    }
    
  })
}

function totalDiscountCalculation(cart) {
  // let totalDiscount = (cart.total_compare_at - cart.original_total_price) / 100
  // console.log('totalDiscount', totalDiscount);
  // console.log('cart total original', cart.original_total_price);
  // console.log('the total calculated subtotal of cart is ', cart.total_price);

  // cart.items.forEach((item) => { 
  //   if (item.handle == "build-a-system") {
  //     let buildSystemDiscont = 0
  //     const timestamp = item.properties['Timestamp']
  //     if (!timestamp) return

  //     const priceElement = $(`[data-product-timestamp="${timestamp}"]`).find('.cart__item-price')
  //     let price = Number(priceElement.attr('data-cost')) / 100
  //     if (item.properties['Price Without Discount']) {
  //       buildSystemDiscont = (item.properties['Price Without Discount'] - price) * item.quantity
  //     }

  //     totalDiscount += buildSystemDiscont
  //   }

  //   //FREECAPSULEPROMO:ID -- recalculate the total discount for the cart for offer items
  //   // MEMORIALDAYPROMO
  //   if((item.handle == 'the-132' || item.handle == 'the-extender') && item.properties['Offer'] && item.original_price){
  //     totalDiscount += item.original_price / 100;
  //   }
  // })
  // $('[data-cart-saved]').text(`($${totalDiscount.toFixed(2)})`)

  let total = (cart.original_total_price / 100).toFixed(2).replace('.00', '').replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  let subtotal = (cart.total_price / 100).toFixed(2).replace('.00', '').replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  //hide unneded ones
  $('.cart__details.before-savings, .cart__details.shipping-line').hide();

  //hide the strikethrough in the buttons, these were tested and are not needed
  $('[data-cart-button-strikethrough-price]').text('').hide();
  $('[data-cart-button-price]').text('').hide();

  if(cart.currency == 'USD'){
    if(cart.original_total_price > cart.total_price){
      $('[data-cart-button-strikethrough-price]').text(`$${total}`);
      $('.cart__details.before-savings').show();
      $('[data-cart-before-savings]').text(`$${total}`);
      $('[data-cart-button-price]').text(`$${subtotal}`);
    }else{
      $('[data-cart-button-strikethrough-price]').text('');
      $('[data-cart-button-price]').text(`$${subtotal}`);
    }
    if(cart.original_total_price > 6500){
      $('.cart__details.shipping-line').show();
    }
  }else{
    if(cart.original_total_price > cart.total_price){
      $('[data-cart-button-strikethrough-price]').text('');
      $('[data-cart-button-price]').text('');
    }
  }

  // if (typeof affirm !== 'undefined') {
  //   //set the data-amount attribute to the price
  //     console.log('refreshing the affirm messaggio');
  //   if(affirm.jsReady()){
  //     $('.fixed .affirm-as-low-as').attr('data-amount', price * 100);
  //     affirm.ui.refresh();
  //   }
  // }
}

$(document).ready(function() {
  
  // console.log('cart.js loaded')
  // $('.cart_clear').click(function() {
  //   console.log('clear cart')
  //   $('.js-modal-open-bas-confirm-modal').click()
  //   $('#bas-confirm-modal .modal__centered-header').text(CONFIRM_DELETE_ALL_CART_ITEMS)
  //   $('#bas-confirm-modal .modal__centered-copy').hide()
  //   $('#bas-confirm-modal .btn-confirm').text('Remove')
  //   $('#bas-confirm-modal').data('item', 'all')
  //   $('#bas-confirm-modal').data('type', 'cart')
  //   $('.subpage, .quick-shop').removeClass('active')
  //   $('#shopify-section-cad-header').show()
  //   $('body').removeClass('modal-open')
  //   $('.subpage-video-block-controls-icon-pause').click()
  //   $('.quick-shop').removeClass('above_cart')
  //   $('.quick-shop .quick-shop-content > div').remove()
  // })

  // console.log('post cart.js update loaded')
  // $('.add-gift-note-checkbox input').change((e) => {
  //   const target = $(e.target)
  //   const wrapper = target.closest('.add-gift-note-checkbox')

  //   console.log('add-gift-note-checkbox change', target.is(':checked'));
  //   if (target.is(':checked')) {
  //     wrapper.next().show()
  //     return
  //   }
    
  //   wrapper.next().hide()
  //   $('.cart-textarea-wrapper').removeClass('active')
  //   $.post('/cart/update.js', { attributes: { 'Gift message': '' } })
  // })

  $('body').trigger('updateCart', [false, false]);

})

$('.cart_clear').click(function() {
  console.log('clear cart')
  $('.js-modal-open-bas-confirm-modal').click()
  $('#bas-confirm-modal .modal__centered-header').text(CONFIRM_DELETE_ALL_CART_ITEMS)
  $('#bas-confirm-modal .modal__centered-copy').hide()
  $('#bas-confirm-modal .btn-confirm').text('Remove')
  $('#bas-confirm-modal').data('item', 'all')
  $('#bas-confirm-modal').data('type', 'cart')
  $('.subpage, .quick-shop').removeClass('active')
  $('#shopify-section-cad-header').show()
  $('body').removeClass('modal-open')
  $('.subpage-video-block-controls-icon-pause').click()
  $('.quick-shop').removeClass('above_cart')
  $('.quick-shop .quick-shop-content > div').remove()
})


$('#bas-confirm-modal .btn-confirm').click(() => {
  const {item, type} = $('#bas-confirm-modal').data()
  if (type !== "cart") return
  if (item === 'all')
    return $.post('/cart/clear.js').then(() => $('body').trigger('updateCart', [false, false]))

  const id = $('#bas-confirm-modal').data('id')
  theme.cart.changeItem(id, 0);
})

$('#bas-confirm-modal .btn-cancel').click(() => {
  const {item, type, itemEl, input, self, id} = $('#bas-confirm-modal').data()
  if (type !== "cart" || item === 'all') return

  itemEl.attr('data-cart-item-id', id);
  input.val(1);
  self.loading(false);
  theme.cart.changeItem(id, 1);
})

calcPriceWithAdditional = async function (cart) {
  cart.items.forEach((item) => {
    // CHECKOUTEXTENSIBILITY
    const parentTimestamp = item.properties['_Parent Timestamp'] || item.properties['Parent Timestamp']
    const quantity = item.properties['_Quantity'] || item.properties['Quantity'] || 1
    const curItemEl = $(`[data-cart-item-id="${item.key}"]`)
    if (item.properties) {
      const discountPrice = item.properties['_Price Without Discount'] || item.properties['Price Without Discount']
      const giftCardAmount = item.properties['Gift card amount']
      const $compare = curItemEl.find('[data-product-price-compare]')
      if (discountPrice?.length) $compare.text(` $${discountPrice}`)
      else if (giftCardAmount?.length)  $compare.text(` $${(item.compare_at_price / 100 + Number(giftCardAmount.replace('$', ''))).toFixed(2)}`)
    }
    if (!parentTimestamp) return
  
    //if this is a build a system item...
    curItemEl.hide() // hide the item
    // const scratchedPrice = $(`[data-product-timestamp="${parentTimestamp}"] [data-product-price-compare]`).eq(0).clone()
    // get the current price element
    const priceElement = $(`[data-product-timestamp="${parentTimestamp}"]`).find('.cart__item-price') 
    // calculate the price
    let price = Number(priceElement.attr('data-cost'))

    //add up the price of the item to the parent one
    price = (parseFloat(price) + parseFloat(item.final_price) * quantity)
    //update the html with the latest price
    priceElement.html(`${theme.Currency.formatMoney(price, theme.settings.moneyFormat).replace('.00', '')}`).attr('data-cost', price)

    // NEW STUFF!! SET THE ORIGINAL PRICING FOR THE BUILD A SYSTEM!!!
    // return; //USE THIS IF WE WANT TO TURN THIS OFF
    
    let og_price = Number(priceElement.attr('data-original-cost'))
    // if og price is not a number, set it to 0 to avoid NaN
    if (isNaN(og_price)) og_price = 0
    og_price = (parseFloat(og_price) + parseFloat(item.original_price) * quantity)

    priceElement.attr('data-original-cost', og_price)
    if(og_price > price){
      //set the strikethrough price
      priceElement.html(`<del class="cart__item-price--original">${theme.Currency.formatMoney(og_price, theme.settings.moneyFormat).replace('.00', '')}</del> ${theme.Currency.formatMoney(price, theme.settings.moneyFormat).replace('.00', '')}`)
    }else{
      return;
    }

    //set the discount list to one of the items
    const discountList = curItemEl.find('[data-cart-item-discount-list]')
    if (discountList.length) {
      const parentDiscountList = $(`[data-product-timestamp="${parentTimestamp}"] [data-cart-item-discount-list]`)
      parentDiscountList.html(discountList.html())
    }

    // priceElement.prepend(scratchedPriceText)
  })
  $('#CartDrawer').removeClass('loading')

}

$(document).ready(() => {
  $.get('/browsing_context_suggestions.json').then((data) => {
    const country = data.detected_values.country.handle
    $('html').attr('country', country)
  })

  // FREECAPSULEPROMO -- rework the cart pending hat offer
  //here is the logic for adding the hat when they click the button
  $('.cart-pending-hat .add-to-cart-button').click((e) => {
    if ($(e.currentTarget).hasClass('disabled')) return

    // const hatFreeAdded = theme.cart.items.find((item) => item.variant_id === patent_hat_variant_id_free)
    // const hatAdded = theme.cart.items.find((item) => item.variant_id === patent_hat_variant_id)
    // if (hatFreeAdded || hatAdded) return
    // const hatVariantId = isReturningCustomer() ? patent_hat_variant_id : patent_hat_variant_id_free


    //get the selected variant id from the selector that we're going to build
    $('.add-to-cart-button').addClass('disabled')
    
    //default capsule id
    //FREECAPSULEPROMO:ID
    //MEMORIALDAYPROMO

    let free_capsule_variant_id = 40595786694741; 
    const selectElement = document.getElementById('free-capsule-variant');
    const productType = document.getElementById('free-capsule-type').value;
    if(selectElement.value){
      console.log('selected variant id is: ' + selectElement.value);
      console.log('product type is: ' + productType);
      free_capsule_variant_id = selectElement.value;
    }

    let item_properties = {
      "Label": '*Blank Label*', 
      "Custom Label": '', 
      "Customization Cost": '', 
      'Offer': 'Free Item'
    }

    if(productType == 'extender'){
      item_properties = {
        'Offer': 'Free Item'
      }
    }
    
    $.post(
      '/cart/add.js', 
      { items: [
        { id: free_capsule_variant_id, 
          quantity: 1,
          properties: item_properties
        }] 
      }).then(() => {
        $('body').trigger('updateCart', [false, false])
        $('.add-to-cart-button').removeClass('disabled')
    })
  })

  

  function clearGiftMessages() {
    $.post('/cart/update.js', { attributes: { 'Gift message': '' } })
  }
})